module.exports = __webpack_public_path__ + "img/icon-expired.9d770d6a.png";